module.exports = __webpack_public_path__ + "static/media/veryhappy.de1c0530.svg";